import React from 'react';
import {Navigate} from "react-router";
import {useSelector} from "react-redux";
import {NotFound} from "../pages/NotFound";
import {LOGIN, MAIN} from "../common/links";
import {SUCCESS} from "../common/statuses";

const PrivateRoute = ({children, roles}) => {
    const {status, current} = useSelector(state => state.auth);

    if (status !== SUCCESS) {
        // user is not authenticated
        return <Navigate to={LOGIN}/>;
    }
    // todo: Подумать про аннонимных пользователей, в данный момент это заглушка.
    // не указывать role для анонимных пользователей
    if (!roles) {
        return children;
    }
    if (!roles.includes(current.role)) {
        return <NotFound/>;
    }
    return children;
};

export default PrivateRoute
